import * as React from "react";
import { Control, useFieldArray, useWatch } from "react-hook-form";
import {
  Text,
  Grid,
  Title,
  Button,
  ActionIcon,
  Modal,
  Group,
  Divider,
  useMantineTheme,
  Stack,
  Flex,
} from "@mantine/core";

import {
  CCheckbox,
  CMultiSelect,
  CMultiSelectCreatable,
  CRadioGroup,
  CSelect,
  CTextarea,
  CTextInput,
} from "@supportinitiative/react-hook-form-mantine";
import { IconPlus, IconTrash } from "@tabler/icons-react";

import { QuerySetCVMContext } from "./QuerySetCVMContext";

import { getId } from "../../utilities";
import { useLoaders } from "../../hooks";
import { SECTIONCOLORS } from "./QuerySetUtils";

function PreferencesCVM({ name, control }: { name: `definition`; control: Control<any> }) {
  const { state: querySetFormState, dispatch: reconsetFormDispatch } = React.useContext(QuerySetCVMContext);

  const theme = useMantineTheme();

  const inputsArray = useFieldArray({
    control,
    name: `${name}.inputs`,
    keyName: "key",
  });

  const { data: loaders } = useLoaders(querySetFormState.entityId);

  return (
    <Stack
      style={{
        marginTop: theme.spacing.xs,
        // padding: theme.spacing.xs,
        width: "100%",
      }}
    >
      <Stack gap="0" style={{ background: SECTIONCOLORS[1], padding: theme.spacing.sm }}>
        <Flex>
          <Title
            mb="xs"
            order={5}
            style={{
              padding: "0px 5px",
              backgroundColor: "#16A596",
              color: "#fff",
            }}
          >
            Command
          </Title>
        </Flex>
        <Grid gutter={"xs"} mb="xs">
          <Grid.Col span={4}>
            <CTextInput
              name="definition.command"
              control={control}
              required
              showErrorText={false}
              disabled={querySetFormState.actionOptions.disableAll}
            />
          </Grid.Col>
        </Grid>
      </Stack>

      <Stack gap="0" style={{ background: SECTIONCOLORS[1], padding: theme.spacing.sm }}>
        <Flex>
          <Title
            mb="xs"
            order={5}
            style={{
              padding: "0px 5px",
              backgroundColor: "#16A596",
              color: "#fff",
            }}
          >
            Loader
          </Title>
        </Flex>

        <Grid align="flex-start" gutter={"xs"} mb="lg" style={{ display: "flex", alignItems: "flex-end" }}>
          <Grid.Col span={4}>
            <CSelect
              name={`definition.loaderId`}
              placeholder="Loader"
              control={control}
              data={
                loaders && loaders.length > 0
                  ? loaders.map((loader: any) => {
                      return { label: loader.name, value: loader.id };
                    })
                  : []
              }
              disabled={querySetFormState.actionOptions.disableAll}
            />
          </Grid.Col>
        </Grid>
      </Stack>

      {/*       <Stack gap="0">
        <Flex>
          <Title
            mb="xs"
            mt="xs"
            order={5}
            style={{
              padding: "0px 5px",
              backgroundColor: "#16A596",
              color: "#fff",
            }}
          >
            Run
          </Title>
        </Flex>

        <Grid align="stretch" gutter={"xs"} mb="xs">
          <Grid.Col span={4}>
            <CRadioGroup
              name={`${name}.preferences.run`}
              control={control}
              data={[
                { label: "Workflow", value: "WORKFLOW" },
                { label: "Direct", value: "DIRECT" },
              ]}
              disabled={querySetFormState.actionOptions.disableAll}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <CRadioGroup
              name={`${name}.preferences.runManagement`}
              control={control}
              data={[{ label: "DB_DIRECT", value: "DB_DIRECT" }]}
              disabled={querySetFormState.actionOptions.disableAll}
            />
          </Grid.Col>
        </Grid>
      </Stack> */}
    </Stack>
  );
}

export default PreferencesCVM;
